import AlertIcon from '../../icons/alert';
import Button from '../button/button';
import { describeApiError } from '../../../core/network/error';

import './styles/state-message.css';

export default function ErrorState({ error, title = 'No pudimos cargar esto', onRetry }) {
    return (
        <div className="state-message state-message--error" role="alert">
            <span className="state-message__icon"><AlertIcon /></span>
            <p className="state-message__title">{title}</p>
            <p className="state-message__description">{describeApiError(error)}</p>
            {onRetry && (
                <div className="state-message__action">
                    <Button size="small" onClick={onRetry}>Reintentar</Button>
                </div>
            )}
        </div>
    );
}
